export class ExtraFee {
    public id?: string;
    public uniteAmount?: string;
    public percentage?: string;
    public type?: string;
    public label?: string;
    public quantity?: number;
    public totalAmount?: string;


    constructor(id: string, uniteAmount: string, percentage: string, type: string, label: string, quantity: number, totalAmount: string) {
        this.id = id;
        this.uniteAmount = uniteAmount;
        this.percentage = percentage;
        this.type = type;
        this.label = label;
        this.quantity = quantity;
        this.totalAmount = totalAmount;
    }
}
